module.exports = __webpack_public_path__ + "73a0d42b8cd1034d0a35a11a9ab6f8c1.jpg";